import {createTheme} from '@mui/material/styles';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9',
    },
    secondary: {
      main: '#f48fb1',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Arial", sans-serif',
  },
  components: {
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: '#182231',
          backgroundImage: 'none',
          textTransform: 'none',
          '&.Mui-disabled': {
            backgroundColor: '#0C1119',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: '#5265FF',
          color: '#FFFFFF',
        },
      },
    },
  },
});

export default darkTheme;
